// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3-InV8nMA_hvEVnB86zDXd","title":"_3N2LylcxmlDcoN7L1N8Y_H","body":"vpNcbg5XDdaK9HRXS71vC"};